import React from 'react';
import Upload from './Upload';
const Dragger = function Dragger(props) {
    const { style, height } = props;
    return React.createElement(Upload, Object.assign({}, props, { type: "drag", style: { ...style, height } }));
};
export default Dragger;
